/* sx-perf (Owen 24 Oct 2026: "some stuff is kinda slow loading").
   iOS (and the Instagram in-app browser) only starts a loading="lazy" image when it is almost on screen, so cards
   scrolled into view sat blank, and quick-add photos only began downloading when the sheet opened. This starts both
   a screen or so early. Nothing else changes: same images, same sizes.
   25 Oct 2026: flipping the visible <img> from lazy to eager left WebKit (iOS Safari and Chrome) showing the broken
   "?" image on the homepage Shop by brand cards. Now the image is warmed with a detached copy (same src, srcset and
   sizes, so the same file) and the page's own <img> is never touched; the browser then paints it from cache.
   Any image that still errors gets two quiet retries. */
(function () {
  function retry(i) {
    if (!i || i.tagName !== 'IMG' || (i.__sxr || 0) >= 2) return;
    i.__sxr = (i.__sxr || 0) + 1;
    setTimeout(function () {
      var s = i.getAttribute('src'), ss = i.getAttribute('srcset');
      if (ss) { i.removeAttribute('srcset'); i.setAttribute('srcset', ss); }
      if (s) { i.removeAttribute('src'); i.setAttribute('src', s); }
    }, 900 * i.__sxr);
  }
  document.addEventListener('error', function (e) { retry(e.target); }, true);
  function sweep() {
    document.querySelectorAll('img').forEach(function (i) { if (i.complete && i.currentSrc && !i.naturalWidth) retry(i); });
  }
  function warm(i) {
    var w = new Image(), sz = i.getAttribute('sizes'), ss = i.getAttribute('srcset'), s = i.getAttribute('src');
    if (sz) w.sizes = sz;
    if (ss) w.srcset = ss;
    if (s) w.src = s;
  }
  window.addEventListener('load', sweep);
  if (!('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var t = e.target; io.unobserve(t);
      if (t.tagName === 'IMG') { if (t.loading === 'lazy') warm(t); return; }
      t.querySelectorAll('[data-sx-qa-img]').forEach(function (b) { var u = b.getAttribute('data-sx-qa-img'); if (u) new Image().src = u; });
      var p = t.querySelector('[data-sx-qa-preview]'), f = p && p.getAttribute('data-sx-qa-fallback');
      if (f) new Image().src = f;
    });
  }, { rootMargin: '1200px 800px 1200px 800px' });
  function scan() {
    document.querySelectorAll('img[loading="lazy"], .sx-qa').forEach(function (n) { if (!n.__sxp) { n.__sxp = 1; io.observe(n); } });
  }
  scan();
  document.addEventListener('sx:lm:appended', scan);
  window.addEventListener('load', scan);
})();
